/* eslint-disable */

if (!String.prototype.startsWith) {
  Object.defineProperty(
    String.prototype,
    'startsWith',
    {
      value(search, pos) {
        return this.substring(!pos || pos < 0 ? 0 : +pos, search.length) === search
      },
    },
    // @ts-expect-error ts-migrate(2554) FIXME: Expected 3 arguments, but got 4.
    true,
  )
}
